import { render, staticRenderFns } from "./GalleryPost.vue?vue&type=template&id=1ecc730c&scoped=true&"
import script from "./GalleryPost.vue?vue&type=script&lang=js&"
export * from "./GalleryPost.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPost.vue?vue&type=style&index=0&id=1ecc730c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc730c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VIcon,VImg,VResponsive,VRow,VSkeletonLoader})
